
import CpntBlocPresentationDetail from "../../components/CpntBlocPresentationDetail";
import { ContactSujetIds } from "../../config/helpers";
import img_gestion_catalogue_1 from "../../images/presentation/gestion_catalogue_1.jpg"
import "./PagePresentation.scss"


const description1 =
  <>
    <p>
    Cet espace dédié aux professionnels du livre (éditeurs, diffuseurs, distributeurs), vous permet de <b>visualiser à loisir et gratuitement votre fonds éditorial.</b><br/><br/>
Vous pouvez agir sur les notices bibliographiques de vos marques éditoriales, les mettre à jour autant de fois que nécessaire. Toutes les modifications sont prises en compte quotidiennement dans la base de données Electre.<br/><br/>
 Vous pouvez également, en cas de besoin, corriger les informations commerciales de votre société ou encore programmer des alertes de suivi des dates de parution de vos ouvrages.<br/><br/>
<b>Vous gérez votre compte de façon autonome</b>, plusieurs personnes de votre organisation peuvent y avoir accès, c&apos;est vous qui pilotez l&apos;administration de vos utilisateurs.
    </p>
</>
;

const description2 =
  <>
  <div className="mt-4">
        <p className="text-md-start text-justify">
        Par le biais de cet espace, <b>vous communiquez avec votre chargé(e) des relations éditeurs</b>. Chaque éditeur, diffuseur ou distributeur a un interlocuteur unique, c&apos;est à lui que vous adressez toutes les informations utiles à votre référencement ou que vous demandez une création de notice, si vous ne la trouvez pas dans votre catalogue.<br/><br/><b>Vous êtes également en lien avec les experts référentiels</b> du service qualité d&apos;Electre qui peuvent répondre à vos demandes particulières sur des sujets relatifs aux normes ou encore à la transition bibliographique.<br/><br/>
Grâce à cet espace dédié, Electre vous offre une <b>gestion simplifiée et efficace de vos notices bibliographiques</b> et de vos données commerciales. En vous garantissant un référencement précis et actualisé, nous accompagnons votre activité au quotidien, afin de <b>valoriser au mieux votre catalogue et optimiser votre visibilité auprès des acteurs du livre</b>.
        </p>
    </div>
  </>
;


const PagePresentation_GestionCatalogue = () => {

   return (
    <>
    <div className="row pt-3 pb-5">
      <div className="col col-md-10 offset-md-1 col-12 ">
        <div className="titre titre-Presentation text-center">Gestion de votre catalogue</div>
      </div>
    </div>
        <CpntBlocPresentationDetail
          description1={description1}
        description2={description2}
          img_rond={img_gestion_catalogue_1}
          linktext="Nous contacter"
          contactsujet={ContactSujetIds.GestionDeVotreCatalogue}
        />
      </>
  );
};

export default PagePresentation_GestionCatalogue;
